var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentAttach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 4.875H20.8916C21.5213 4.8751 22.1251 5.13182 22.5704 5.58873L33.0546 16.3488C33.4998 16.8058 33.7499 17.4255 33.75 18.0718V32.9062C33.75 33.8759 33.3747 34.8059 32.7066 35.4916C32.0385 36.1773 31.1323 36.5625 30.1875 36.5625H14.75C13.8052 36.5625 12.899 36.1773 12.2309 35.4916C11.5628 34.8059 11.1875 33.8759 11.1875 32.9062V23.1562",
    stroke: "#D4C1BF",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 5.48438V14.625C21.875 15.2715 22.1252 15.8915 22.5706 16.3486C23.016 16.8057 23.6201 17.0625 24.25 17.0625H33.1562",
    stroke: "#D4C1BF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 6.09375V17.6719C12.3781 17.9128 12.3341 18.152 12.2457 18.3752C12.1573 18.5984 12.0262 18.8012 11.8602 18.9716C11.6942 19.142 11.4966 19.2766 11.279 19.3673C11.0615 19.4581 10.8285 19.5032 10.5938 19.5C9.70312 19.5 8.8125 18.8068 8.8125 17.6719V6.70312C8.8125 4.37303 10.0423 2.4375 12.375 2.4375C14.7077 2.4375 15.9375 4.32656 15.9375 6.6559V17.2247C15.9375 20.5001 13.8727 23.1562 10.5938 23.1562C7.31477 23.1562 5.25 20.5009 5.25 17.2247V10.9688",
    stroke: "#D4C1BF",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAttach);
export default __webpack_public_path__ + "static/media/document-attach.8327058c5ed32389e017638af3ff22c7.svg";
export { ForwardRef as ReactComponent };